module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACaSURBVHgB7ZO9CsMwDITPah/EXQodM5WOffKMIVPGQJb4ReIkwuQPEwyRsvmbZAx3QicBmYwUc/ZRNa0lPEquv8X7hYtQQtwCIyRQQtx5+D8EmJT4r/g4CDB3ih8M6qbrg7gKblmMXQayMI9sWs+l4JEQaB6RsdyBx6A7IibkoGsSHZq2SXQHLBZ2f3Tzc71mNYPYRDP8TOYKEzniTcFZACM+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/pages/adminRegister/assets/Arrow_Right_LG.png
// module id = kdV7
// module chunks = 1